<div class="wrapper" style="">

  <div style="display: flex;flex-direction: column;align-items: center;" class="form-wrapper">
    <div style="text-align: center"><img src="/assets/images/logo_horizontaal_RGB.svg" class="logo" alt="">
    </div>

    <form action="">
      <div class="signintext" translate>Select a project</div>
      <select name="p" id="" class="form-control custom_dropdown mb-4" [(ngModel)]="project">
        <option *ngFor="let p of projects" [ngValue]="p" >{{p.project_name}}</option>
      </select>
      <div class="d-flex justify-content-around w-100">
        <button
          (click)="chooseProject()"
          class="btn btn-warning text-white ld-ext-right"
          [ngClass]="{'running': sub && !sub.closed}"
          [disabled]="sub && !sub.closed">
          <span translate>SUBMIT</span>

          <div class="ld ld-ring ld-spin"></div>
        </button>
        <button (click)="cancel()" class="btn cancel-btn text-white" translate>CANCEL</button>
      </div>
    </form>
  </div>

</div>
